import React from "react";
import OrderList from "../components/OrderList";
import PanelLayout from "../components/PanelLayout";
import { ListSkeleton } from "../components/Skeleton";
import { Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import { FaFileInvoiceDollar } from "react-icons/fa";
import * as actions from "../redux/actions/ordersActions";
import "./styles/OrderListPage.css";

class PanelOrder extends React.Component {
  componentDidMount() {
    this.fetchOrdersList();
  }

  fetchOrdersList = async () => {
    try {
      await this.props.LoadOrders(this.props.user_id, this.props.token).then(() => {
        if (this.props.error) {
          alert(this.props.error);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      <PanelLayout>
        <div className="pay-orders">
          <header className="pay-orders__header pay-orders__header--commercial">
            <div className="pay-orders__header-icon" aria-hidden="true">
              <FaFileInvoiceDollar />
            </div>
            <div>
              <p className="pay-orders__eyebrow">
                <Translate value="order_receipt_official" />
              </p>
              <h1>
                <Translate value="pay_orders" />
              </h1>
              <p>
                <Translate value="pay_orders_subtitle" />
              </p>
            </div>
          </header>

          {this.props.loading ? <ListSkeleton /> : <OrderList />}
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    orderList: reducer.orders.list,
    error: reducer.orders.error,
    loading: reducer.orders.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadOrders: (user_id, token) =>
    dispatch(actions.loadList({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelOrder);
